import EmployeeSalarySocialSecurityComponents from "../components/EmployeeSalarySocialSecurity";
import useEmployeeSalarySocialSecurity from "../hooks/useEmployeeSalarySocialSecurity";

function EmployeeSalarySocialSecurity() {
  const employeeSalarySocialSecurityProps = useEmployeeSalarySocialSecurity();
  return <EmployeeSalarySocialSecurityComponents {...employeeSalarySocialSecurityProps} />;

}

export default EmployeeSalarySocialSecurity;
